import { Pipe, PipeTransform } from '@angular/core';
import { GlobalAssetsService } from '../services/global-assets/global-assets.service';

@Pipe({
    name: 'globalAsset',
    standalone: false
})
export class GlobalAssetPipe implements PipeTransform {
    constructor(private _assetService: GlobalAssetsService) {}

    transform(value: string, localResource?: boolean): string {
        return this._assetService.resolveAsset(value, localResource);
    }
}
